import React from "react";
import "../../Media.css"
import { ScrollingGallery } from "../../ScrollingGallery";




const Gallery = () => {
  return (
    <div className="media-page-wrapper page-content">
      <div className="media-header mt-5">
        <h1>Gallery</h1>
        <p className="text-center">
          Reliving the moments that shape the future of Indian Travel, Tourism,
          and Hospitality.
        </p>
        <div className="accent-line"></div>
      </div>
      <ScrollingGallery/>
    </div>
  )
};

export default Gallery;
